import React, { useEffect, useRef, useState } from "react";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import { useTheme } from "@emotion/react";
import S from "./MessageInput.styled";
import SmileIcon from "../../assets/icons/SmileButton";
import { useClickOutside } from "../../hooks";
const EmojiButton = ({ value, setValue }) => {
    const [showEmojiPicker, setShowEmojiPicker] = useState(false);
    const emojiRef = useRef(null);
    const emojiBtnRef = useRef(null);
    const { color } = useTheme();
    useClickOutside(emojiRef, () => setShowEmojiPicker(false));
    const toggleEmojiPicker = () => setShowEmojiPicker(!showEmojiPicker);
    const addEmoji = (emoji) => {
        const valueWithEmoji = `${value}${emoji.native}`;
        setValue(valueWithEmoji);
        setShowEmojiPicker(false);
    };
    const escapeEvent = (e) => {
        var _a;
        if (e.key === "Escape") {
            setShowEmojiPicker(false);
            (_a = emojiBtnRef === null || emojiBtnRef === void 0 ? void 0 : emojiBtnRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    useEffect(() => {
        if (!emojiRef)
            return;
        if (!emojiRef.current)
            return;
        if (showEmojiPicker) {
            emojiRef.current.addEventListener("keydown", escapeEvent, true);
        }
        else {
            emojiRef.current.removeEventListener("keydown", escapeEvent, true);
        }
        return () => {
            var _a;
            (_a = emojiRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener("keydown", escapeEvent, true);
        };
    }, [showEmojiPicker]);
    return (React.createElement(React.Fragment, null,
        showEmojiPicker ? (React.createElement(S.EmojiContainer, { ref: emojiRef },
            React.createElement(Picker, { theme: color.background === "#fff" ? "light" : "dark", data: data, onEmojiSelect: addEmoji, perLine: 6, autoFocus: true }))) : null,
        React.createElement(S.Btn, { ref: emojiBtnRef, onClick: toggleEmojiPicker, "data-testid": "emojibutton" },
            React.createElement(SmileIcon, null))));
};
export default EmojiButton;
//# sourceMappingURL=EmojiButton.js.map